import React from 'react';
import styled from 'styled-components/macro';
import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router';
import { getSecondaryColor } from 'lib/context/theme/utils';

const Header = styled.div`
  justify-content: space-between;
  display: flex;
  margin-bottom: 12px;
`;
const Title = styled.div`
  font-weight: 500;
  font-size: 14px;
  line-height: 20px;
  color: ${({ theme }) => theme.colors.black[100]};
`;
const Manage = styled.div`
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  text-decoration-line: underline;
  cursor: pointer;
  color: ${({ theme }) => theme.colors.primary[100]}; /** SUS-961 changes **/
`;
const Main = styled.div`
  font-weight: 600;
  font-size: 16px;
  line-height: 24px;
  color: ${({ theme }) => getSecondaryColor(theme)};
`;
const Labels = styled.div`
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  color: ${({ theme }) => theme.colors.neutral[60]};
`;

type Props = {
  addonData: any;
};

export const AddonsOverview = ({ addonData }: Props) => {
  const { t } = useTranslation();
  const history = useHistory();

  const Addons: any = {
    captions: t('Captions'),
    droplr: t('File sharing'),
    lpb: t('Landing page builder'),
    sms: t('SMS'),
    smsTierOne: t('SMS'),
    smsTierTwo: t('SMS'),
    smsTierThree: t('SMS'),
  };

  const getAddonLabels = () => {
    let addonStringArr: any = [];
    for (let i = 0; i < addonData.length; i++) {
      if (addonData[i].active) {
        addonStringArr.push(Addons[addonData[i].name]);
      }
    }
    return addonStringArr.join(', ');
  };

  return (
    <>
      <Header>
        <Title>{t('Add-ons')}</Title>
        <Manage onClick={() => history.push('/profile/add-ons')}>
          {t('Manage')}
        </Manage>
      </Header>
      <Main>
        {t('{{count}} active', {
          count: addonData.filter((e: any) => !!e.active).length,
        })}
      </Main>
      <Labels>{getAddonLabels()}</Labels>
    </>
  );
};
